import React from 'react';
import Reset_Pass from './Reset_Pass';

const Reset_PassApp = () => {
  return (
    <div className="App">
      <Reset_Pass />
    </div>
  );
};

export default Reset_PassApp;
